import { useLocation, useRoutes } from 'react-router-dom';
import routes from './routes';
import StagingGate from './app/components/StagingGate';
import ErrorBoundary from './app/components/ErrorBoundary';
import { useQrScanner } from './hooks/useQrScanner';
import Loader from './app/components/Loader';

const App = (props: any) => {
  const element = useRoutes(routes)
  const location = useLocation();
  const { isScanning, isNavigating } = useQrScanner();
  return (
    <StagingGate>
      <ErrorBoundary resetKey={location.pathname}>{element}</ErrorBoundary>
      <Loader timedOut={isScanning || isNavigating} message={isNavigating ? 'Opening scanned link...' : 'Reading QR code...'} />
    </StagingGate>
  )
}

export default App;
